<div class="container p-0 pb-3">
    <div class="d-flex gap-2">
        
        

        @if (enableApplyButton())
        {
            <div  class="flex-fill">  
                <is-busy-button id="apply-button"
                                (execute)="applyClicked()" 
                                [isBusy]="isBusy()"
                                [disabled]="!isValid()" 
                                [css]="applyCss() ? applyCss(): 'btn w-100 clip3 corner position-relative primary-border secondary-bg secondary-text-100 font-4 rounded-0 py-2'">
                    <span>{{applyButtonName()}}</span>
                </is-busy-button>                            
            </div>
        }

        @if (enableSubmitButton())
        {
            <div  class="flex-fill">  
                <is-busy-button id="submit-button"
                                (execute)="submitClicked()" 
                                [isBusy]="isBusy()"
                                [disabled]="!isValid()" 
                                [css]="submitCss() ? submitCss(): 'btn w-100 clip3 corner position-relative primary-border secondary-bg secondary-text-100 font-4 rounded-0 py-2  flex-fill'"
                                >
                    <span>{{actionButtonName()}}</span>
                </is-busy-button>                            
            </div>
        }

        @if(enableCancelButton()){
            <div class="flex-fill">
                <button id="cancel-button" 
                        type="button" 
                        (click)="cancelClicked()" 
                        [disabled]="isBusy()"
                        [class]="cancelCss() ? cancelCss():'btn w-100 clip3 corner position-relative primary-border primary-text-100 font-4 rounded-0 py-2'">
                    <span>{{closeBtnName()}}</span>
                </button>
            </div>
        }
    </div>
</div>